<template>
  <VBlock class="payment-wrapper" :direction="Direction.column">
    <VButton
      class="payment-button"
      :color="!isUnderMinimumOrderPrice || isReturnAndExchangeItemInCart ? ButtonColor.brand : ButtonColor.disable"
      :radius="4"
      :onClick="onPayment"
    >
      <VBlock v-if="!isLoading" :sort="Sort.center_center">
        <VBlock
          v-show="!isUnderMinimumOrderPrice || isReturnAndExchangeItemInCart"
          class="circle"
          :sort="Sort.center_center"
        >
          <!-- <VBlock class="blank"></VBlock> -->
          <VSpan
            class="circle-text"
            :text="totalQuantity > 999 ? `${totalQuantity}+` : totalQuantity"
            :weight="TextWeight.bold"
            :color="TextColor.brand"
            :size="14"
          />
          <!-- <VBlock class="blank"></VBlock> -->
        </VBlock>
        <VSpan
          class="price-text"
          :text="!isUnderMinimumOrderPrice || isReturnAndExchangeItemInCart ? `${totalPrice}원 배달 주문하기` : '최소주문금액을 채워주세요'"
          :color="TextColor.white"
          :weight="TextWeight.bold"
          :type="TextType.Number"
          :size="18"
        />
      </VBlock>
      <VBlock v-else class="loading-indicator"></VBlock>
    </VButton>
    <VBlock class="padding-bottom-layer"></VBlock>
  </VBlock>
</template>

<script>
import VSpan, {
  TextColor,
  TextWeight,
  TextType
} from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'

import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'

export default {
  name: 'CartPaymentButton',
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    isUnderMinimumOrderPrice: {
      type: Boolean,
      required: true
    },
    isReturnAndExchangeItemInCart: {
      type: Boolean,
      required: true
    },
    totalPrice: {
      type: Number,
      required: true
    },
    totalQuantity: {
      type: Number,
      required: true
    },
    onPayment: {
      type: Function,
      required: true
    }
  },
  components: {
    VSpan,
    VButton,
    VBlock
  },
  data() {
    return {
      Direction,
      Sort,
      TextColor,
      TextWeight,
      TextType,
      ButtonColor
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

.payment-wrapper {
  position: fixed;
  z-index: 5;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding: 10px 10px 0 10px;

  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%);
  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%);
  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%);

  .padding-bottom-layer {
    padding-bottom: 10px;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 10px);
    padding-bottom: calc(env(safe-area-inset-bottom) + 10px);
    background-color: $white;
  }

  .payment-button {
    width: 100%;
    height: 50px;

    .circle {
      display: inline-flex;
      width: auto;
      min-width: 22px;
      max-width: 40px;
      height: 22px;
      border-radius: 100px;
      background-color: $background-white;
      margin-right: 8px;
      box-sizing: border-box;
      padding-left: 4px;
      padding-right: 4px;

      .circle-text {
        width: auto;
        height: 19px;
        text-align: center;
      }
      // .blank {
      //   padding: 2px;
      // }
    }

    .price-text {
      margin-top: 1px;
      width: auto;
    }

    .loading-indicator {
      position: relative;
      width: 100%;
      height: 100%;
      pointer-events: none;

      &:after {
        display: block;
        position: absolute !important;
        left: 50%;
        top: 50%;
        border-width: 3px;
        border-style: solid;
        border-radius: 290486px;
        border-color: transparent transparent #fff #fff !important;
        height: 12px;
        width: 12px;
        margin: -6px 0 0 -6px;
        content: '';
        animation: spinAround 0.5s infinite linear;
      }
    }
  }
}
</style>
